import { useQuery } from '../models/reactUtils'
import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog'
import useMediaQuery from '@mui/material/useMediaQuery'

import { theme } from '../utils/theme'
import BookingPath from './BookingPath'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'

const Modal = observer(() => {
  const { store } = useQuery()
  const { t } = useTranslation()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const maybeOnClose = () => {
    if (window.confirm(t('Are you sure you want to leave this screen?'))) {
      return store.modalClose()
    }
  }
  return (
    <Dialog
      id="InteliblyDialog"
      open={store.modalOpen}
      onClose={maybeOnClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      sx={{
        minWidth: !fullScreen ? 600 : 'auto',
        transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      }}
    >
      <DialogTitle onClose={maybeOnClose} />
      <DialogContent>
        <BookingPath />
      </DialogContent>
    </Dialog>
  )
})

Modal.displayName = 'Modal'

export default Modal
